import { FC } from "react";
import { FcGoogle } from "react-icons/fc";
import { Link } from "react-router-dom";
import Button from "./EnterpriseButton";
interface Props {
  buttonText: string;
  buttonLink: string;
  description: string;
  googleButtonText: string;
}

export const AuthAlternative: FC<Props> = ({
  buttonText,
  buttonLink,
  description,
  googleButtonText,
}) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center justify-center gap-2 text-[#DCDEE3]">
      <div className="h-px bg-[#DCDEE3] flex-grow" />
      <span className="font-satoshi text-[#707A8F]">Or</span>
      <div className="h-px bg-[#DCDEE3] flex-grow" />
    </div>
    <Button
      text={googleButtonText}
      btnType="button"
      type="transparent"
      className="w-full !text-black hover:!text-bblue active:!text-bblue"
      style={{ borderColor: "#DCDEE3" }}
      LeftIcon={<FcGoogle size={16} />}
    />
    <p className="text-center text-base font-medium font-satoshi text-bash">
      {description}{" "}
      <Link to={buttonLink} className="text-bblue hover:underline">
        {buttonText}
      </Link>
    </p>
  </div>
);
